import React, { Component } from "react";
import { Row, Col } from "reactstrap";
import { translate } from "react-i18next";
import styled from "styled-components";

const ErrorMessage = styled.p`
  color: red;
  text-align: center;
`;

export class PageErrorFooter extends Component {
  constructor(props) {
    super();
  }

  createFooter= step => {
    const { t } = this.props;
    return (
      <React.Fragment>
        <Row>
          <Col sm="12">
          <ErrorMessage>{t("common.error")}</ErrorMessage>
          </Col>
        </Row>
      </React.Fragment>
    );
  };

  render() {
    return <React.Fragment>{this.createFooter()}</React.Fragment>;
  }
}

export default translate("translate")(PageErrorFooter);
